import { UserModel } from "@/app/entities";
import { UiButton, UiTable } from "@/components/ui";
import { UserTypes } from "@/composables/users";
import { useAuthStore } from "@/context";
import { UserApiResponse } from "@/context/stores/user.store";
import { View, Edit, Unlock, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface UserTableProps {
  users: UserApiResponse;
  loading?: boolean;
  deleting?: boolean;
  matricule?: string;
  onEdit: (user: UserModel) => void;
  onDelete: (user: UserModel) => void;
  onAddUser: () => void;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
}

export function UserTable({
  users,
  loading = false,
  deleting,
  matricule,
  onEdit,
  onDelete,
  onPageChange,
  onPageSizeChange,
}: UserTableProps) {
  const navigate = useNavigate();
  const { currentUser } = useAuthStore();

  const columns: any[] = [
    {
      accessor: "matricule",
      title: "Matricule",
    },
    {
      accessor: "nom",
      title: "Nom",
    },
    {
      accessor: "prenom",
      title: "Prénom",
    },
    {
      accessor: "email",
      title: "Email",
    },
    {
      accessor: "type",
      title: "Type",
    },
  ];

  if (
    [UserTypes.ADMINISTRATEUR, UserTypes.TECHNIQUE].includes(
      currentUser?.type as UserTypes
    )
  ) {
    columns.push({
      accessor: "actions",
      title: "Actions",
      render: (row: UserModel) => {
        return (
          <div className="flex gap-2">
            <UiButton
              color="info"
              onClick={() => navigate(`/dashboard/users/${row.matricule}`)}
            >
              <View />
            </UiButton>
            <UiButton onClick={() => onEdit(row)}>
              <Edit />
            </UiButton>
            <UiButton
              color="warning"
              withAlert={true}
              confirmMessage={`Êtes-vous sûr de vouloir ${
                row.disabled ? "débloquer" : "bloquer"
              } cet utilisateur ?`}
              okLabel={row.disabled ? "Débloquer" : "Bloquer"}
              disabled={deleting && row.matricule === matricule}
              loading={deleting && row.matricule === matricule}
              onClick={() => onDelete(row)}
            >
              {row.disabled ? (
                <>
                  <Unlock /> Débloquer
                </>
              ) : (
                <>
                  <Lock /> Bloquer
                </>
              )}
            </UiButton>
          </div>
        );
      },
    });
  }

  return (
    <>
      <UiTable
        loading={loading}
        columns={columns}
        rows={users.content}
        totalElements={users.totalElements}
        striped={false}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        page={users.number + 1}
        totalPages={users.totalPages}
      />
    </>
  );
}
